import React, { useEffect, useState } from "react";
import { getUniversalCasinoTVAPI } from "../service/casino/index.js";

// Remount on game changes so a previous game's stream is never displayed.
export default function CasinoTV({ casinoGames, aspectRatio = "16 / 9" }) {
  return <CasinoTVPlayer key={casinoGames} casinoGames={casinoGames} aspectRatio={aspectRatio} />;
}

function CasinoTVPlayer({ casinoGames, aspectRatio }) {
  const [stream, setStream] = useState(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    let refreshTimer;

    const loadTV = async () => {
      try {
        if (!casinoGames) throw new Error("Missing casino game");
        const data = await getUniversalCasinoTVAPI(casinoGames, controller.signal);
        if (controller.signal.aborted) return;
        const response = data?.response;
        if (data?.code !== 200 || !response?.iframeUrl) {
          throw new Error("TV unavailable");
        }
        const url = new URL(response.iframeUrl);
        if (url.protocol !== "https:" && url.protocol !== "http:") {
          throw new Error("Invalid TV URL");
        }
        setStream(response);
        setError(false);
        const expiresIn = Number(response.expiresIn);
        if (Number.isFinite(expiresIn) && expiresIn > 0) {
          refreshTimer = setTimeout(
            loadTV,
            Math.min(Math.max(expiresIn * 900, 1000), 2147483647)
          );
        }
      } catch {
        if (!controller.signal.aborted) {
          setStream(null);
          setError(true);
        }
      }
    };

    setError(false);
    loadTV();
    return () => {
      controller.abort();
      clearTimeout(refreshTimer);
    };
  }, [casinoGames, attempt]);

  return (
    <div
      style={{ width: "100%", aspectRatio, background: "#000", position: "relative" }}
    >
      {stream ? (
        <iframe
          src={stream.iframeUrl}
          title={`${casinoGames} live casino TV`}
          data-event-id={stream.eventId}
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          style={{ display: "block", width: "100%", height: "100%", border: 0 }}
        />
      ) : (
        <div
          role="status"
          style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: "#fff", gap: 8, zIndex: 1 }}
        >
          {error ? "Casino TV is unavailable." : "Loading casino TV…"}
          {error && casinoGames && (
            <button type="button" onClick={() => setAttempt((value) => value + 1)}>
              Retry
            </button>
          )}
        </div>
      )}
    </div>
  );
}
